jQuery(function ($) {
  // .js-address が存在するフォーム
  $('.js-address').each(function () {
    var $container = $(this);
    var $zipInput = $container.find('input[name="text-post"]');
    var $addrInput = $container.find('input[name="text-address"]');
    var $btn = $container.find('.js-postInput');

    if (!$zipInput.length || !$addrInput.length || !$btn.length) return;

    // 郵便番号を正規化
    function normalizeZip(v) {
      return String(v || '').replace(/[^\d]/g, '').slice(0, 7);
    }

    // 住所を取得してセット
    function fetchAddress(zip) {
      zip = normalizeZip(zip);
      if (zip.length !== 7) return;

      $.ajax({
        url: 'https://zipcloud.ibsnet.co.jp/api/search',
        data: { zipcode: zip },
        dataType: 'json',
        timeout: 8000
      }).done(function (data) {
        if (data && data.status === 200 && data.results && data.results[0]) {
          var r = data.results[0];
          var addr = r.address1 + r.address2 + r.address3;
          if (/以下に掲載がない場合/.test(r.address3)) addr = r.address1 + r.address2;

          // 住所フィールドにセット
          $addrInput.val(addr);
        }
      }).fail(function () {
        // 必要に応じてエラー処理
        console.warn('住所取得に失敗しました');
      });
    }

    // ボタンクリックで住所自動入力
    $btn.on('click', function (e) {
      e.preventDefault();
      fetchAddress($zipInput.val());
    });
  });
});

//
// ハンバーガーメニュー用のJS
//
document.addEventListener("DOMContentLoaded", () => {
	const header = document.querySelector(".l-header");
	const toggleButton = document.querySelector(".hamburger");
	const navMenu = document.querySelector(".headerNav");
	const menuLinks = header.querySelectorAll("a");

	const setMenuState = (open) => {
		header.classList.toggle("_isOpen", open);
		document.body.classList.toggle("_noScroll", open);
		toggleButton.setAttribute("aria-expanded", open);
		navMenu.setAttribute("aria-hidden", !open);
	};

	// ハンバーガークリック
	toggleButton.addEventListener("click", () => {
		setMenuState(!header.classList.contains("_isOpen"));
	});

	// 外側クリックで閉じる
	document.addEventListener("click", (e) => {
		if (!navMenu.contains(e.target) && !toggleButton.contains(e.target)) {
			setMenuState(false);
		}
	});

  // ここから任意
  
  		// 少しでもスクロールしたらclassを外す
		const updateScrollState = () => {
	
	  // === 0は0px以外で外す、> 10は10px以上で外す
		  header.classList.toggle("_isTop", window.scrollY < 80);
		};

		window.addEventListener("scroll", updateScrollState, {
		  passive: true,
		});
		
		updateScrollState();

	// mvに入ったらクラスをつける
	const mv = document.querySelector(".mv");
	if (!mv) return;

	new IntersectionObserver(([e]) => header.classList.toggle("_inMv", e.isIntersecting)).observe(mv);
});


document.addEventListener('DOMContentLoaded', () => {
  // 複製対象の親クラスを配列で指定
  const targetClasses = ['c-btnMain', 'c-btnBig'];

  // 配列をカンマ区切りにして querySelectorAll に渡す
  const selector = targetClasses.map(cls => `.${cls}`).join(', ');
  const targets = document.querySelectorAll(selector);

  // 親要素ごとに処理
  targets.forEach(target => {
    const spans = target.querySelectorAll('span');

    spans.forEach(span => {
      const clone = span.cloneNode(true);
      clone.classList.add('_clone'); // 複製用クラスを追加
			clone.setAttribute('aria-hidden', 'true'); // スクリーンリーダーに無視させる
      target.appendChild(clone);
    });
  });
});

// 
// 要素がフワッて上がってくる、発火は一度だけ
// 


document.addEventListener('DOMContentLoaded', () => {
// 監視対象を取得
const fadeElements = document.querySelectorAll('.js-fadeUp');

// ビューポート内にいるかどうかを判定する関数
function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top < window.innerHeight &&
    rect.bottom > 0
  );
}

// 初期処理：表示されていなければ._isHiddenを付与
fadeElements.forEach(el => {
  if (!isInViewport(el)) {
    el.classList.add('_isHidden');
  }
});


// IntersectionObserverの設定
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.remove('_isHidden');
      observer.unobserve(entry.target); // 一度だけ発火するように
    }
  });
}, {
    // 要素の10％がビューポートに入ったタイミングでアニメーションを開始
  threshold: 0.1
});

// スクロールで監視スタート（_isHiddenがついたもののみ）
fadeElements.forEach(el => {
  if (el.classList.contains('_isHidden')) {
    observer.observe(el);
  }
});

});

// 
// TOPサービスセクションのホバー
// 
document.addEventListener('DOMContentLoaded', () => {
  const serviceLinks = document.querySelectorAll('.service-link');

  let currentLink = null;

   const activateLink = (activeLink) => {
    serviceLinks.forEach((link) => {
      link.classList.remove('_isHover');
    });

    activeLink.classList.add('_isHover');
  };

  serviceLinks.forEach((link) => {
    link.addEventListener('mouseenter', () => {
      activateLink(link);
    });

    link.addEventListener('focus', () => {
      activateLink(link);
    });
  });
});

// 
// タブのJS
// 
document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".c-tabs");
    
        // .c-tabsが存在しない場合は早期リターン
    if (tabs.length === 0) return;


    tabs.forEach(tabContainer => {
        const buttons = tabContainer.querySelectorAll(".c-tabs-btn");
        const contents = tabContainer.querySelectorAll(".c-tabs-cont");

        buttons.forEach(button => {
            button.addEventListener("click", () => {
                // 全てのボタンとコンテンツを非アクティブ化
                buttons.forEach(btn => btn.classList.remove("_active"));
                contents.forEach(content => content.classList.remove("_active"));

                // 対応するタブをアクティブ化
                button.classList.add("_active");
                const tabId = button.dataset.tab;
                tabContainer.querySelector(`#${tabId}`).classList.add("_active");
            });
        });
    });
});

// 
// アコーディオン
// 
document.querySelectorAll('.js-accordionWrap').forEach(accordion => {
  const buttons = accordion.querySelectorAll('.accordion-btn');
  const content = accordion.querySelector('.accordion-cont');

  // アニメーション後、autoに切り替える（動的対応のため）
  content.addEventListener('transitionend', () => {
    if (accordion.classList.contains('_isOpen')) {
      content.style.height = 'auto'; // ←ここがキモ
    }
  });

  const openAccordion = () => {
    // 1. 一度 height を auto にして、scrollHeight を正確に取得
    content.style.height = 'auto';
    const height = content.scrollHeight + 'px';

    // 2. 一度リセットしてからアニメーション用に数値を代入
    content.style.height = '0px'; // ← これがないと transition 効かない
    requestAnimationFrame(() => {
      content.style.height = height;
    });

    accordion.classList.add('_isOpen');
  };

  const closeAccordion = () => {
    // 1. 固定値にしてアニメーション
    content.style.height = content.scrollHeight + 'px';

    // 2. 直後に 0 に戻す
    requestAnimationFrame(() => {
      content.style.height = '0px';
      accordion.classList.remove('_isOpen');
    });
  };

  buttons.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();

      // data-scroll がある場合はスクロール
const scrollTarget = button.getAttribute('data-scroll');
if (scrollTarget) {
  const targetElement = document.querySelector(scrollTarget);
  if (targetElement) {
    const offset = 80; // 画面上から80px下げる
    const elementRect = targetElement.getBoundingClientRect();
    const elementTop = elementRect.top + window.pageYOffset;
    window.scrollTo({
      top: elementTop - offset, // 80px上にスクロール
      behavior: 'smooth'
    });
  }
}

      // アコーディオンの開閉
      if (accordion.classList.contains('_isOpen')) {
        closeAccordion();
      } else {
        openAccordion();
      }
    });
  });

  // 初期化
  content.style.height = '0';
});

document.addEventListener("DOMContentLoaded", () => {
  const currentCont = document.querySelector(".js-currentCont");
  if (!currentCont) return;

  const outlineItems = currentCont.querySelectorAll(".js-outline [data-cont]");
  const contentItems = currentCont.querySelectorAll(".js-cont [data-cont]");

  const updateCurrent = () => {
    const viewportHeight = window.innerHeight;
    const topLimit = viewportHeight * 0.1;      // 上10%
    const bottomLimit = viewportHeight * 0.7;   // 下10%

    let foundCont = null;

    contentItems.forEach(cont => {
      const rect = cont.getBoundingClientRect();
      const contTop = rect.top;
      const contBottom = rect.bottom;

      // 要素が中央80%に少しでも入った場合
      if (contBottom > topLimit && contTop < bottomLimit) {
        foundCont = cont.dataset.cont;
      }
    });

    outlineItems.forEach(item => {
      if (foundCont && item.dataset.cont === foundCont) {
        item.classList.add("_isCurrent");
      } else {
        item.classList.remove("_isCurrent");
      }
    });
  };

  window.addEventListener("scroll", updateCurrent, { passive: true });
  window.addEventListener("resize", updateCurrent);

  updateCurrent();
});

document.addEventListener("DOMContentLoaded", () => {
  const filterBtns = document.querySelectorAll(".factoryFilter .filterBtn");
  const areas = document.querySelectorAll(".factory-area");

  filterBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      const target = btn.dataset.target;

      // ボタンの _isActive クラスを付け替え
      filterBtns.forEach(b => b.classList.remove("_isActive"));
      btn.classList.add("_isActive");

      // エリアの表示切り替え
      areas.forEach(area => {
        if (target === "all" || area.dataset.area === target) {
          area.classList.add("_isActive");
        } else {
          area.classList.remove("_isActive");
        }
      });
    });
  });

  // 初期状態で「全て」をアクティブに
  const defaultBtn = document.querySelector(".factoryFilter .filterBtn[data-target='all']");
  if (defaultBtn) defaultBtn.click();
});


document.addEventListener("DOMContentLoaded", () => {
  // js-flexiBtn がついたボタンを取得
  const flexiBtns = document.querySelectorAll(".js-flexiBtn");
  if (flexiBtns.length === 0) return;

  flexiBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      // 同じ親（階層）内で listChild クラスを持つ要素を取得
      const parent = btn.parentElement;
      if (!parent) return;

      const targets = parent.querySelectorAll(':scope > .listChild');

      targets.forEach(target => {
        target.classList.toggle("_isActive");
      });
      // ボタン自身にも _isActive を付け外し
      btn.classList.toggle("_isActive");
    });
  });
});

  //
  // ボタンをクリックしたらスクロールして上に戻る
  //
document.addEventListener('DOMContentLoaded', () => {
  const goTopBtn = document.querySelector('.goTop');
  if (!goTopBtn) return;

  goTopBtn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});

// 
// 言語の切り替え用
// 
document.addEventListener("DOMContentLoaded", () => {
  const langElements = document.querySelectorAll(".js-langCheck");
  const htmlEl = document.documentElement;

  function updateLangClass() {
    const htmlLang = htmlEl.lang.toLowerCase();

    // まず js-langCheck の既存クラスをリセット
    langElements.forEach(el => {
      el.classList.remove("_jp", "_en");
      if (htmlLang === "en") {
        el.classList.add("_en");
      }  else {
        el.classList.add("_jp");
      }
    });

    // html 自体にもクラスを付ける
    htmlEl.classList.remove("_jp", "_en");
    if (htmlLang === "en") {
      htmlEl.classList.add("_en");
    }  else {
      htmlEl.classList.add("_jp");
    }
  }

  // 初回実行
  updateLangClass();

  // MutationObserver で <html lang="…"> を監視
  const observer = new MutationObserver(mutationsList => {
    mutationsList.forEach(mutation => {
      if (mutation.type === "attributes" && mutation.attributeName === "lang") {
        updateLangClass();
      }
    });
  });

  observer.observe(htmlEl, { attributes: true });
});